import {AnalyticsProvider} from '@github-ui/analytics-provider'
import {PreviewCardOutlet} from '@github-ui/preview-card'
import {SharedLayout} from '@github-ui/shared-dashboard-surface/components/shared/SharedLayout'

import {RepoPullsDashboardHeader, RepoPullsDashboardSidebar} from './RepoPullsDashboardHeader'

export function RepoPullsDashboardLayout() {
  return (
    <AnalyticsProvider
      appName="repo-pulls-dashboard-surface"
      category="Repository Pull Requests"
      metadata={{page: 'repo-pulls-dashboard'}}
    >
      <div data-issue-and-pr-hovercards-enabled>
        <SharedLayout header={<RepoPullsDashboardHeader />} sidebar={<RepoPullsDashboardSidebar />} />
        <PreviewCardOutlet />
      </div>
    </AnalyticsProvider>
  )
}
